<template>
  <div class="row">
    <div class="col-md-12 d-flex justify-content-between">
      <h1 class="h3 mb-3 text-gray-800">
        {{ $t("Meus Atendimentos") }}
      </h1>
    </div>
    <div class="col-md-12">
      <MeusAtendimentos />
    </div>
  </div>
</template>
<script>
import MeusAtendimentos from "./reports/includes/Home.vue";
export default {
  components: {
    MeusAtendimentos,
  },
};
</script>
<style>
</style>
